/** Optimistic local update with GitHub write and rollback on failure. */
export async function runOptimisticGithubWrite(opts: {
  applyLocal: () => void;
  rollback: () => void;
  write: () => Promise<void>;
  onSuccess?: () => void | Promise<void>;
  onFailure: (err: Error) => void | Promise<void>;
}): Promise<void> {
  opts.applyLocal();
  try {
    await opts.write();
    if (opts.onSuccess) await opts.onSuccess();
  } catch (err) {
    opts.rollback();
    await opts.onFailure(err instanceof Error ? err : new Error(String(err)));
  }
}
